import React from 'react';
import { IUserPlayedWithFeed } from '@pvplevelup/core/dist/queries/user/user';
import { ProfilePlayedWith } from 'components/Profile/ProfilePlayedWith';

interface Props {
  playedWithFeed: IUserPlayedWithFeed | undefined;
  fetchMoreRecords: ()=>void;
  byCharacter: boolean;
  onChangeByUser: (byCharacter:boolean)=>void;
}

/** The user page's Played With tab. */
const UserPlayedWith: React.FC<Props> = ({playedWithFeed,fetchMoreRecords,byCharacter,onChangeByUser}) => {
  return (
    <ProfilePlayedWith playedWithFeed={playedWithFeed} fetchMoreRecords={fetchMoreRecords} byCharacter={byCharacter}
      onChangeByCharacter={onChangeByUser} />
  );
};

export {UserPlayedWith};
